import { render, staticRenderFns } from "./NewEmergencyContact.vue?vue&type=template&id=8407d328"
import script from "./NewEmergencyContact.vue?vue&type=script&lang=js"
export * from "./NewEmergencyContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports